import { proNavigator } from "single-spa/react-app/ProNavigator";
import { fetchSiteInfoQuery } from "app/services/sitesService/queries/sitesQueries";
import type { ISiteInfoItem } from "app/services/sitesService/types";

type DomainsGAStatus = Pick<ISiteInfoItem, "privacyStatus" | "hasGaToken"> & { domain: string };

const getDomainsGAStatus = (domains: string) => {
    //Helper function to get domains data from server in Order to decide if ga is available per domain
    if (domains) {
        const domainsArr = domains.split(",");
        return fetchSiteInfoQuery({ keys: domains }).then((data) => {
            if (!data) {
                return [];
            }
            return domainsArr.reduce((acc: DomainsGAStatus[], domain) => {
                const siteInfo = data[domain] as Pick<ISiteInfoItem, "privacyStatus" | "hasGaToken"> | undefined;
                if (siteInfo) {
                    const { privacyStatus, hasGaToken } = siteInfo;
                    acc.push({
                        domain: domain,
                        privacyStatus,
                        hasGaToken,
                    });
                }
                return acc;
            }, []);
        });
    }
    return Promise.resolve([]);
};

const isShowEstimationsVsGaToggle = (domains: string): Promise<boolean> => {
    const currentPageGASupported = !!proNavigator.current().data.gaSupport;
    return new Promise((resolve, reject) => {
        if (currentPageGASupported) {
            getDomainsGAStatus(domains).then((domainsStatus) => {
                for (let i = 0; i < domainsStatus.length; i++) {
                    const currentStatus = domainsStatus[i];
                    if (currentStatus && currentStatus.hasGaToken) {
                        resolve(true);
                    }
                }
                resolve(false);
            });
        } else {
            resolve(currentPageGASupported);
        }
    });
};

export const connectedAssetsService = {
    isShowEstimationsVsGaToggle,
};
